import styled from 'styled-components';
import highlight from 'assets/images/highlight.jpg';
import highlightMobile from 'assets/images/highlight-mobile.jpg';

import { fonts } from 'styles';
export const Container = styled.main`
  width: 100%;
  margin: 0 auto;
`;

export const Header = styled.header`
  width: 100%;
  height: 100vh;
  background: url(${highlight}) no-repeat center center;
  background-size: cover;

  img {
    width: 100%;
    object-fit: contain;
    display: none;
  }

  @media screen and (max-width: 500px) {
    background: none;
    height: auto;
    img {
      display: block;
    }
  }
`;

export const HighlightMobile = styled.img.attrs({ src: highlightMobile })``;

export const Content = styled.section`
  width: 100%;
  padding: 80px 40px;

  @media screen and (max-width: 500px) {
    padding: 64px 40px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 736px;
  margin: 0 auto;
  margin-bottom: 48px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  line-height: 26px;
  color: #3b38b9;
  text-align: center;

  @media screen and (max-width: 500px) {
    text-align: left;
  }
`;

export const Author = styled.span`
  display: block;
  font-family: ${fonts.BentonSansMedium};
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  text-transform: uppercase;
  color: #3b38b9;

  @media screen and (max-width: 500px) {
    text-align: left;
  }
`;
